import { useState } from "react";
import MobileViewerContext from "./MobileViewerContext";

const MobileViewerState = (props) => {
  const [showMobileReportModal, setShowMobileReportModal] = useState(false);
  const [openMoreOptions, setOpenMoreOptions] = useState(false);
  const [showHistory, setShowHistory] = useState(false);
  const [slideReportOpen, setSlideReportOpen] = useState(false); 

  return (
    <MobileViewerContext.Provider
      value={{
        showMobileReportModal,
        setShowMobileReportModal,
        openMoreOptions,
        setOpenMoreOptions,
        showHistory,
        setShowHistory,
        slideReportOpen,
        setSlideReportOpen,
      }}
    >
      {" "}
      {props.children}
    </MobileViewerContext.Provider>
  );
};

export default MobileViewerState;
